import { useState, useEffect } from 'react';
import { fetchAllOrdersDeliveredAtForReportAsync } from '../fetch/fetchAllOrdersDeliveredAtForReportAsync';
import { Region } from '../types/orderTypes';
import { Dayjs } from 'dayjs';
import { ReqEnum } from '../const/requestStatus';
import { CourierInvoice } from '../types/reportTypes';

export function useFetchOrdersDeliveredAtForReport(
  startDate: Dayjs,
  endDate: Dayjs,
  region: Region = undefined
): [CourierInvoice[], ReqEnum] {
  const [fetchStatus, setFetchStatus] = useState<ReqEnum>(ReqEnum.INIT);
  const [courierInvoiceList, setCourierInvoiceList] = useState<
    CourierInvoice[]
  >([]);

  useEffect(() => {
    setFetchStatus(ReqEnum.PENDING);
    const fetchOrders = async (
      startDate: Dayjs,
      endDate: Dayjs,
      region: Region
    ) => {
      const courierInvoiceList: CourierInvoice[] =
        await fetchAllOrdersDeliveredAtForReportAsync(
          startDate,
          endDate,
          region
        );
      setCourierInvoiceList(courierInvoiceList);
      setFetchStatus(ReqEnum.SUCCESS);
    };
    fetchOrders(startDate, endDate, region);
  }, [startDate, endDate, region]);

  return [courierInvoiceList, fetchStatus];
}
